/* tslint:disable */
/* eslint-disable */
/**
 * Private
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface CreatorCreatorSlugCommunitiesConfig
 */
export interface CreatorCreatorSlugCommunitiesConfig {
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunity}
   * @memberof CreatorCreatorSlugCommunitiesConfig
   */
  community?: CreatorCreatorSlugCommunitiesConfigCommunity | null;
}
/**
 *
 * @export
 * @interface CreatorCreatorSlugCommunitiesConfigCommunity
 */
export interface CreatorCreatorSlugCommunitiesConfigCommunity {
  /**
   *
   * @type {string}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunity
   */
  updateFrequency?: CreatorCreatorSlugCommunitiesConfigCommunityUpdateFrequencyEnum;
  /**
   *
   * @type {string}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunity
   */
  creatorDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunity
   */
  targetAudience?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunity
   */
  inside?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunity
   */
  offerSummary?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunity
   */
  creatorAchievements?: Array<string>;
  /**
   *
   * @type {Array<CreatorCreatorSlugCommunitiesConfigCommunityReviews>}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunity
   */
  reviews?: Array<CreatorCreatorSlugCommunitiesConfigCommunityReviews> | null;
  /**
   *
   * @type {Array<CreatorCreatorSlugCommunitiesConfigCommunityFaq>}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunity
   */
  faq?: Array<CreatorCreatorSlugCommunitiesConfigCommunityFaq> | null;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityVideo}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunity
   */
  video?: CreatorCreatorSlugCommunitiesConfigCommunityVideo | null;
}

export const CreatorCreatorSlugCommunitiesConfigCommunityUpdateFrequencyEnum = {
  Daily: 'daily',
  TwoThreePerWeek: 'twoThreePerWeek',
  Weekly: 'weekly',
  TwoThreePerMonth: 'twoThreePerMonth',
  Occasionally: 'occasionally',
} as const;

export type CreatorCreatorSlugCommunitiesConfigCommunityUpdateFrequencyEnum =
  typeof CreatorCreatorSlugCommunitiesConfigCommunityUpdateFrequencyEnum[keyof typeof CreatorCreatorSlugCommunitiesConfigCommunityUpdateFrequencyEnum];

/**
 *
 * @export
 * @interface CreatorCreatorSlugCommunitiesConfigCommunityAvatar
 */
export interface CreatorCreatorSlugCommunitiesConfigCommunityAvatar {
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunityAvatar
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunityAvatar
   */
  url?: string;
}
/**
 *
 * @export
 * @interface CreatorCreatorSlugCommunitiesConfigCommunityFaq
 */
export interface CreatorCreatorSlugCommunitiesConfigCommunityFaq {
  /**
   *
   * @type {string}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunityFaq
   */
  question?: string;
  /**
   *
   * @type {string}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunityFaq
   */
  answer?: string;
}
/**
 *
 * @export
 * @interface CreatorCreatorSlugCommunitiesConfigCommunityReviews
 */
export interface CreatorCreatorSlugCommunitiesConfigCommunityReviews {
  /**
   *
   * @type {string}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunityReviews
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunityReviews
   */
  text?: string;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunityReviews
   */
  avatar?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
}
/**
 *
 * @export
 * @interface CreatorCreatorSlugCommunitiesConfigCommunityVideo
 */
export interface CreatorCreatorSlugCommunitiesConfigCommunityVideo {
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunityVideo
   */
  videoFileId?: number | null;
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunityVideo
   */
  coverFileId?: number | null;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunityVideo
   */
  file?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof CreatorCreatorSlugCommunitiesConfigCommunityVideo
   */
  cover?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
}
/**
 *
 * @export
 * @interface CreatorCreatorSlugCommunitiesLives
 */
export interface CreatorCreatorSlugCommunitiesLives {
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesLives
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesLives
   */
  startAt?: number;
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesLives
   */
  duration?: number;
}
/**
 *
 * @export
 * @interface CreatorCreatorSlugCommunitiesMarketingPriceConfig
 */
export interface CreatorCreatorSlugCommunitiesMarketingPriceConfig {
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesMarketingPriceConfig
   */
  iosPrice?: number;
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesMarketingPriceConfig
   */
  iosTrialPrice?: number;
}
/**
 *
 * @export
 * @interface CreatorCreatorSlugCommunitiesSubscription
 */
export interface CreatorCreatorSlugCommunitiesSubscription {
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesSubscription
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesSubscription
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesSubscription
   */
  lastPaymentDate?: number | null;
  /**
   *
   * @type {string}
   * @memberof CreatorCreatorSlugCommunitiesSubscription
   */
  type?: CreatorCreatorSlugCommunitiesSubscriptionTypeEnum;
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesSubscription
   */
  startedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesSubscription
   */
  cancelledAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesSubscription
   */
  price?: number;
  /**
   *
   * @type {boolean}
   * @memberof CreatorCreatorSlugCommunitiesSubscription
   */
  isActive?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CreatorCreatorSlugCommunitiesSubscription
   */
  inApp?: boolean;
  /**
   *
   * @type {number}
   * @memberof CreatorCreatorSlugCommunitiesSubscription
   */
  nextPaymentDate?: number | null;
}

export const CreatorCreatorSlugCommunitiesSubscriptionTypeEnum = {
  ForeverFree: 'foreverFree',
  FreeTrial: 'freeTrial',
  PaidTrial: 'paidTrial',
  FullPrice: 'fullPrice',
} as const;

export type CreatorCreatorSlugCommunitiesSubscriptionTypeEnum =
  typeof CreatorCreatorSlugCommunitiesSubscriptionTypeEnum[keyof typeof CreatorCreatorSlugCommunitiesSubscriptionTypeEnum];

/**
 *
 * @export
 * @interface DiscoverSpacesCategoriesSpacesIds
 */
export interface DiscoverSpacesCategoriesSpacesIds {
  /**
   *
   * @type {number}
   * @memberof DiscoverSpacesCategoriesSpacesIds
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof DiscoverSpacesCategoriesSpacesIds
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof DiscoverSpacesCategoriesSpacesIds
   */
  deletedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof DiscoverSpacesCategoriesSpacesIds
   */
  spaceId?: number;
  /**
   *
   * @type {number}
   * @memberof DiscoverSpacesCategoriesSpacesIds
   */
  categoryId?: number;
  /**
   *
   * @type {number}
   * @memberof DiscoverSpacesCategoriesSpacesIds
   */
  order?: number | null;
}
/**
 *
 * @export
 * @interface ExpertExpertIdSpacesMarketingPriceConfig
 */
export interface ExpertExpertIdSpacesMarketingPriceConfig {
  /**
   *
   * @type {number}
   * @memberof ExpertExpertIdSpacesMarketingPriceConfig
   */
  previousPrice?: number | null;
}
/**
 *
 * @export
 * @interface ExpertLinks
 */
export interface ExpertLinks {
  /**
   *
   * @type {number}
   * @memberof ExpertLinks
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ExpertLinks
   */
  href?: string;
  /**
   *
   * @type {string}
   * @memberof ExpertLinks
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof ExpertLinks
   */
  order?: number;
}
/**
 *
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
  /**
   *
   * @type {boolean}
   * @memberof InlineObject
   */
  isSkipped?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineObject
   */
  isCompleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof InlineObject
   */
  message?: string;
  /**
   *
   * @type {number}
   * @memberof InlineObject
   */
  rate?: number;
}
/**
 *
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse200
   */
  success?: string;
}
/**
 *
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  deletedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  customerId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  clubId?: number | null;
}
/**
 *
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20010
   */
  isAvatar?: boolean;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20010
   */
  slug?: string;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20010
   */
  isSubscribed?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  subscriptionPrice?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20010
   */
  isExpert?: boolean;
  /**
   *
   * @type {Array<ExpertLinks>}
   * @memberof InlineResponse20010
   */
  links?: Array<ExpertLinks>;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse20010
   */
  avatar?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse20011
 */
export interface InlineResponse20011 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20011
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20011
   */
  daysOffset?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20011
   */
  previousStep?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20011
   */
  type?: InlineResponse20011TypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20011
   */
  startAt?: number | null;
  /**
   *
   * @type {SpacesSpaceIdChallengeStepsContent}
   * @memberof InlineResponse20011
   */
  content?: SpacesSpaceIdChallengeStepsContent | null;
  /**
   *
   * @type {SpacesSpaceIdChallengeStepsResult}
   * @memberof InlineResponse20011
   */
  result?: SpacesSpaceIdChallengeStepsResult;
}

export const InlineResponse20011TypeEnum = {
  Post: 'post',
  LiveStream: 'live_stream',
} as const;

export type InlineResponse20011TypeEnum = typeof InlineResponse20011TypeEnum[keyof typeof InlineResponse20011TypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20012
 */
export interface InlineResponse20012 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  deletedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  customerId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  spaceId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  chatRevokedAt?: number | null;
}
/**
 *
 * @export
 * @interface InlineResponse20013
 */
export interface InlineResponse20013 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20013
   */
  id?: number;
  /**
   *
   * @type {InlineResponse20013Space}
   * @memberof InlineResponse20013
   */
  space?: InlineResponse20013Space | null;
  /**
   *
   * @type {InlineResponse20013Creator}
   * @memberof InlineResponse20013
   */
  creator?: InlineResponse20013Creator | null;
}
/**
 *
 * @export
 * @interface InlineResponse20013Creator
 */
export interface InlineResponse20013Creator {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20013Creator
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20013Creator
   */
  name?: string;
}
/**
 *
 * @export
 * @interface InlineResponse20013Space
 */
export interface InlineResponse20013Space {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20013Space
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20013Space
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20013Space
   */
  type?: InlineResponse20013SpaceTypeEnum;
}

export const InlineResponse20013SpaceTypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
  Community: 'community',
} as const;

export type InlineResponse20013SpaceTypeEnum =
  typeof InlineResponse20013SpaceTypeEnum[keyof typeof InlineResponse20013SpaceTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20014
 */
export interface InlineResponse20014 {
  /**
   *
   * @type {Array<InlineResponse20014Members>}
   * @memberof InlineResponse20014
   */
  members?: Array<InlineResponse20014Members>;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20014
   */
  membersCountNumber?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20014
   */
  trialsCountNumber?: number;
}
/**
 *
 * @export
 * @interface InlineResponse20014Members
 */
export interface InlineResponse20014Members {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20014Members
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20014Members
   */
  name?: string;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse20014Members
   */
  avatar?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20014Members
   */
  slug?: string;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20014Members
   */
  isTrial?: boolean;
}
/**
 *
 * @export
 * @interface InlineResponse20015
 */
export interface InlineResponse20015 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015
   */
  publishedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015
   */
  type?: InlineResponse20015TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015
   */
  payment_type?: InlineResponse20015PaymentTypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015
   */
  iosProductId?: string | null;
  /**
   *
   * @type {InlineResponse20015Config}
   * @memberof InlineResponse20015
   */
  config?: InlineResponse20015Config | null;
  /**
   *
   * @type {InlineResponse2004MarketingPriceConfig}
   * @memberof InlineResponse20015
   */
  marketingPriceConfig?: InlineResponse2004MarketingPriceConfig;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015
   */
  userSlug?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20015
   */
  isPurchased?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20015
   */
  isSubscribed?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20015
   */
  isTrial?: boolean;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse20015
   */
  cover?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015
   */
  chatId?: number | null;
  /**
   *
   * @type {InlineResponse2004Creator}
   * @memberof InlineResponse20015
   */
  creator?: InlineResponse2004Creator | null;
  /**
   *
   * @type {Array<InlineResponse20015Tags>}
   * @memberof InlineResponse20015
   */
  tags?: Array<InlineResponse20015Tags>;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesSubscription}
   * @memberof InlineResponse20015
   */
  subscription?: CreatorCreatorSlugCommunitiesSubscription | null;
  /**
   *
   * @type {Array<InlineResponse20015Lives>}
   * @memberof InlineResponse20015
   */
  lives?: Array<InlineResponse20015Lives>;
}

export const InlineResponse20015TypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
  Community: 'community',
} as const;

export type InlineResponse20015TypeEnum = typeof InlineResponse20015TypeEnum[keyof typeof InlineResponse20015TypeEnum];
export const InlineResponse20015PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse20015PaymentTypeEnum =
  typeof InlineResponse20015PaymentTypeEnum[keyof typeof InlineResponse20015PaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20015Config
 */
export interface InlineResponse20015Config {
  /**
   *
   * @type {InlineResponse20015ConfigChallenge}
   * @memberof InlineResponse20015Config
   */
  challenge?: InlineResponse20015ConfigChallenge | null;
  /**
   *
   * @type {InlineResponse20015ConfigLive}
   * @memberof InlineResponse20015Config
   */
  live?: InlineResponse20015ConfigLive | null;
  /**
   *
   * @type {InlineResponse20015ConfigChannel}
   * @memberof InlineResponse20015Config
   */
  channel?: InlineResponse20015ConfigChannel | null;
}
/**
 *
 * @export
 * @interface InlineResponse20015ConfigChallenge
 */
export interface InlineResponse20015ConfigChallenge {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015ConfigChallenge
   */
  finishTimestamp?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigChallenge
   */
  offerDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigChallenge
   */
  offerSummary?: string | null;
}
/**
 *
 * @export
 * @interface InlineResponse20015ConfigChannel
 */
export interface InlineResponse20015ConfigChannel {
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigChannel
   */
  creatorDescription?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigChannel
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigChannel
   */
  targetAudience?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigChannel
   */
  contentFormat?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigChannel
   */
  updateFrequency?: InlineResponse20015ConfigChannelUpdateFrequencyEnum;
}

export const InlineResponse20015ConfigChannelUpdateFrequencyEnum = {
  Daily: 'daily',
  TwoThreePerWeek: 'twoThreePerWeek',
  Weekly: 'weekly',
  TwoThreePerMonth: 'twoThreePerMonth',
  Occasionally: 'occasionally',
} as const;

export type InlineResponse20015ConfigChannelUpdateFrequencyEnum =
  typeof InlineResponse20015ConfigChannelUpdateFrequencyEnum[keyof typeof InlineResponse20015ConfigChannelUpdateFrequencyEnum];

/**
 *
 * @export
 * @interface InlineResponse20015ConfigLive
 */
export interface InlineResponse20015ConfigLive {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015ConfigLive
   */
  startAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015ConfigLive
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigLive
   */
  linkToZoom?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigLive
   */
  creatorDescription?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigLive
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigLive
   */
  requirements?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigLive
   */
  offerDescription?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015ConfigLive
   */
  offerSummary?: string | null;
  /**
   *
   * @type {InlineResponse2004ConfigLiveRecord}
   * @memberof InlineResponse20015ConfigLive
   */
  record?: InlineResponse2004ConfigLiveRecord | null;
  /**
   *
   * @type {Array<InlineResponse2004ConfigLiveTestimonials>}
   * @memberof InlineResponse20015ConfigLive
   */
  testimonials?: Array<InlineResponse2004ConfigLiveTestimonials>;
}
/**
 *
 * @export
 * @interface InlineResponse20015Lives
 */
export interface InlineResponse20015Lives {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015Lives
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015Lives
   */
  startAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015Lives
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015Lives
   */
  link?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015Lives
   */
  creatorDescription?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015Lives
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015Lives
   */
  requirements?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015Lives
   */
  offerDescription?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015Lives
   */
  offerSummary?: string;
  /**
   *
   * @type {InlineResponse2004ConfigLiveRecord}
   * @memberof InlineResponse20015Lives
   */
  record?: InlineResponse2004ConfigLiveRecord | null;
}
/**
 *
 * @export
 * @interface InlineResponse20015Tags
 */
export interface InlineResponse20015Tags {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015Tags
   */
  weight?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20015Tags
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20015Tags
   */
  name?: string;
}
/**
 *
 * @export
 * @interface InlineResponse20016
 */
export interface InlineResponse20016 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20016
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20016
   */
  created_at?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20016
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20016
   */
  bio?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20016
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20016
   */
  isAvatar?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20016
   */
  isExpert?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20016
   */
  subscriptionPrice?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20016
   */
  slug?: string;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20016
   */
  isSubscribed?: boolean;
  /**
   *
   * @type {Array<ExpertLinks>}
   * @memberof InlineResponse20016
   */
  links?: Array<ExpertLinks>;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse20016
   */
  avatar?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
  /**
   *
   * @type {Array<InlineResponse20016Points>}
   * @memberof InlineResponse20016
   */
  points?: Array<InlineResponse20016Points>;
}
/**
 *
 * @export
 * @interface InlineResponse20016Points
 */
export interface InlineResponse20016Points {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20016Points
   */
  points?: number;
  /**
   *
   * @type {InlineResponse20016Tag}
   * @memberof InlineResponse20016Points
   */
  tag?: InlineResponse20016Tag | null;
}
/**
 *
 * @export
 * @interface InlineResponse20016Tag
 */
export interface InlineResponse20016Tag {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20016Tag
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20016Tag
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20016Tag
   */
  color?: string;
}
/**
 *
 * @export
 * @interface InlineResponse20017
 */
export interface InlineResponse20017 {
  /**
   *
   * @type {Array<InlineResponse20017Subscriptions>}
   * @memberof InlineResponse20017
   */
  subscriptions?: Array<InlineResponse20017Subscriptions>;
  /**
   *
   * @type {Array<InlineResponse20017Subscriptions>}
   * @memberof InlineResponse20017
   */
  purchases?: Array<InlineResponse20017Subscriptions>;
}
/**
 *
 * @export
 * @interface InlineResponse20017Subscriptions
 */
export interface InlineResponse20017Subscriptions {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20017Subscriptions
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20017Subscriptions
   */
  name?: string;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20017Subscriptions
   */
  isAvatar?: boolean;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse20017Subscriptions
   */
  avatar?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse20018
 */
export interface InlineResponse20018 {
  /**
   *
   * @type {Array<InlineResponse20018Steps>}
   * @memberof InlineResponse20018
   */
  steps?: Array<InlineResponse20018Steps>;
  /**
   *
   * @type {Array<InlineResponse20018Intro>}
   * @memberof InlineResponse20018
   */
  intro?: Array<InlineResponse20018Intro>;
  /**
   *
   * @type {Array<InlineResponse20018Intro>}
   * @memberof InlineResponse20018
   */
  finish?: Array<InlineResponse20018Intro>;
}
/**
 *
 * @export
 * @interface InlineResponse20018Intro
 */
export interface InlineResponse20018Intro {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Intro
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20018Intro
   */
  type?: InlineResponse20018IntroTypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Intro
   */
  spaceId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Intro
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20018Intro
   */
  content?: object;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20018Intro
   */
  gsMessageId?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Intro
   */
  publishedAt?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20018Intro
   */
  isDraft?: boolean;
}

export const InlineResponse20018IntroTypeEnum = {
  Intro: 'intro',
  Step: 'step',
  Finish: 'finish',
  Deferred: 'deferred',
} as const;

export type InlineResponse20018IntroTypeEnum =
  typeof InlineResponse20018IntroTypeEnum[keyof typeof InlineResponse20018IntroTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20018Posts
 */
export interface InlineResponse20018Posts {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Posts
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20018Posts
   */
  type?: InlineResponse20018PostsTypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Posts
   */
  spaceId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Posts
   */
  stepId?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Posts
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineResponse20018Posts
   */
  content?: object;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20018Posts
   */
  gsMessageId?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Posts
   */
  publishedAt?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20018Posts
   */
  isDraft?: boolean;
}

export const InlineResponse20018PostsTypeEnum = {
  Intro: 'intro',
  Step: 'step',
  Finish: 'finish',
  Deferred: 'deferred',
} as const;

export type InlineResponse20018PostsTypeEnum =
  typeof InlineResponse20018PostsTypeEnum[keyof typeof InlineResponse20018PostsTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20018Result
 */
export interface InlineResponse20018Result {
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20018Result
   */
  isSkipped?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Result
   */
  rate?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20018Result
   */
  message?: string;
}
/**
 *
 * @export
 * @interface InlineResponse20018Steps
 */
export interface InlineResponse20018Steps {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Steps
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20018Steps
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Steps
   */
  startAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20018Steps
   */
  estimatedEffort?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20018Steps
   */
  isSignificant?: boolean;
  /**
   *
   * @type {Array<InlineResponse20018Posts>}
   * @memberof InlineResponse20018Steps
   */
  posts?: Array<InlineResponse20018Posts>;
  /**
   *
   * @type {InlineResponse20018Result}
   * @memberof InlineResponse20018Steps
   */
  result?: InlineResponse20018Result;
}
/**
 *
 * @export
 * @interface InlineResponse20019
 */
export interface InlineResponse20019 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20019
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20019
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019
   */
  type?: InlineResponse20019TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019
   */
  status?: InlineResponse20019StatusEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019
   */
  payment_type?: InlineResponse20019PaymentTypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019
   */
  iosProductId?: string | null;
  /**
   *
   * @type {InlineResponse2005Config}
   * @memberof InlineResponse20019
   */
  config?: InlineResponse2005Config | null;
  /**
   *
   * @type {InlineResponse2004MarketingPriceConfig}
   * @memberof InlineResponse20019
   */
  marketingPriceConfig?: InlineResponse2004MarketingPriceConfig;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019
   */
  userSlug?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20019
   */
  isPurchased?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20019
   */
  isSubscribed?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20019
   */
  chatId?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20019
   */
  isTrial?: boolean;
  /**
   *
   * @type {InlineResponse20019Creator}
   * @memberof InlineResponse20019
   */
  creator?: InlineResponse20019Creator | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20019
   */
  startAt?: number | null;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse20019
   */
  cover?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
}

export const InlineResponse20019TypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
  Community: 'community',
} as const;

export type InlineResponse20019TypeEnum = typeof InlineResponse20019TypeEnum[keyof typeof InlineResponse20019TypeEnum];
export const InlineResponse20019StatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type InlineResponse20019StatusEnum =
  typeof InlineResponse20019StatusEnum[keyof typeof InlineResponse20019StatusEnum];
export const InlineResponse20019PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse20019PaymentTypeEnum =
  typeof InlineResponse20019PaymentTypeEnum[keyof typeof InlineResponse20019PaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20019Creator
 */
export interface InlineResponse20019Creator {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20019Creator
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019Creator
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019Creator
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20019Creator
   */
  isAvatar?: boolean;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse20019Creator
   */
  avatar?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
  /**
   *
   * @type {InlineResponse20019CreatorClub}
   * @memberof InlineResponse20019Creator
   */
  club?: InlineResponse20019CreatorClub | null;
}
/**
 *
 * @export
 * @interface InlineResponse20019CreatorClub
 */
export interface InlineResponse20019CreatorClub {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20019CreatorClub
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20019CreatorClub
   */
  title?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20019CreatorClub
   */
  isFollowed?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20019CreatorClub
   */
  isSubscribed?: boolean;
}
/**
 *
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  iosProductId?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  trialPrice?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2002
   */
  description?: string | null;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfig}
   * @memberof InlineResponse2002
   */
  config?: CreatorCreatorSlugCommunitiesConfig | null;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesMarketingPriceConfig}
   * @memberof InlineResponse2002
   */
  marketingPriceConfig?: CreatorCreatorSlugCommunitiesMarketingPriceConfig;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse2002
   */
  cover?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
  /**
   *
   * @type {Array<CreatorCreatorSlugCommunitiesLives>}
   * @memberof InlineResponse2002
   */
  lives?: Array<CreatorCreatorSlugCommunitiesLives>;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  subscribersCount?: number;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesSubscription}
   * @memberof InlineResponse2002
   */
  subscription?: CreatorCreatorSlugCommunitiesSubscription | null;
}
/**
 *
 * @export
 * @interface InlineResponse20020
 */
export interface InlineResponse20020 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020
   */
  deletedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020
   */
  clubId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20020
   */
  customerId?: number;
}
/**
 *
 * @export
 * @interface InlineResponse20021
 */
export interface InlineResponse20021 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021
   */
  created_at?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021
   */
  bio?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20021
   */
  isAvatar?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20021
   */
  isExpert?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021
   */
  subscriptionPrice?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021
   */
  slug?: string;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20021
   */
  isSubscribed?: boolean;
  /**
   *
   * @type {Array<ExpertLinks>}
   * @memberof InlineResponse20021
   */
  links?: Array<ExpertLinks>;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse20021
   */
  avatar?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
  /**
   *
   * @type {Array<InlineResponse20016Points>}
   * @memberof InlineResponse20021
   */
  points?: Array<InlineResponse20016Points>;
  /**
   *
   * @type {Array<InlineResponse20021Communities>}
   * @memberof InlineResponse20021
   */
  communities?: Array<InlineResponse20021Communities>;
}
/**
 *
 * @export
 * @interface InlineResponse20021Communities
 */
export interface InlineResponse20021Communities {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Communities
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021Communities
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Communities
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021Communities
   */
  payment_type?: InlineResponse20021CommunitiesPaymentTypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021Communities
   */
  iosProductId?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Communities
   */
  trialPrice?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021Communities
   */
  description?: string | null;
  /**
   *
   * @type {InlineResponse20021MarketingPriceConfig}
   * @memberof InlineResponse20021Communities
   */
  marketingPriceConfig?: InlineResponse20021MarketingPriceConfig;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse20021Communities
   */
  cover?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Communities
   */
  subscribersCount?: number;
  /**
   *
   * @type {InlineResponse20021Subscription}
   * @memberof InlineResponse20021Communities
   */
  subscription?: InlineResponse20021Subscription | null;
}

export const InlineResponse20021CommunitiesPaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse20021CommunitiesPaymentTypeEnum =
  typeof InlineResponse20021CommunitiesPaymentTypeEnum[keyof typeof InlineResponse20021CommunitiesPaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse20021MarketingPriceConfig
 */
export interface InlineResponse20021MarketingPriceConfig {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021MarketingPriceConfig
   */
  previousPrice?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021MarketingPriceConfig
   */
  iosPrice?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021MarketingPriceConfig
   */
  iosTrialPrice?: number;
}
/**
 *
 * @export
 * @interface InlineResponse20021Subscription
 */
export interface InlineResponse20021Subscription {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Subscription
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Subscription
   */
  lastPaymentDate?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20021Subscription
   */
  type?: InlineResponse20021SubscriptionTypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Subscription
   */
  startedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Subscription
   */
  cancelledAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Subscription
   */
  price?: number;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse20021Subscription
   */
  isActive?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse20021Subscription
   */
  nextPaymentDate?: number | null;
}

export const InlineResponse20021SubscriptionTypeEnum = {
  ForeverFree: 'foreverFree',
  FreeTrial: 'freeTrial',
  PaidTrial: 'paidTrial',
  FullPrice: 'fullPrice',
} as const;

export type InlineResponse20021SubscriptionTypeEnum =
  typeof InlineResponse20021SubscriptionTypeEnum[keyof typeof InlineResponse20021SubscriptionTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  membersCountNumber?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  trialsCountNumber?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004
   */
  type?: InlineResponse2004TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004
   */
  payment_type?: InlineResponse2004PaymentTypeEnum;
  /**
   *
   * @type {InlineResponse2004Config}
   * @memberof InlineResponse2004
   */
  config?: InlineResponse2004Config | null;
  /**
   *
   * @type {InlineResponse2004MarketingPriceConfig}
   * @memberof InlineResponse2004
   */
  marketingPriceConfig?: InlineResponse2004MarketingPriceConfig;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004
   */
  userSlug?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2004
   */
  isPurchased?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2004
   */
  isSubscribed?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2004
   */
  isTrial?: boolean;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse2004
   */
  cover?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  chatId?: number | null;
  /**
   *
   * @type {InlineResponse2004Creator}
   * @memberof InlineResponse2004
   */
  creator?: InlineResponse2004Creator | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2004
   */
  isFollowed?: boolean;
}

export const InlineResponse2004TypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
  Community: 'community',
} as const;

export type InlineResponse2004TypeEnum = typeof InlineResponse2004TypeEnum[keyof typeof InlineResponse2004TypeEnum];
export const InlineResponse2004PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse2004PaymentTypeEnum =
  typeof InlineResponse2004PaymentTypeEnum[keyof typeof InlineResponse2004PaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse2004Config
 */
export interface InlineResponse2004Config {
  /**
   *
   * @type {InlineResponse2004ConfigChallenge}
   * @memberof InlineResponse2004Config
   */
  challenge?: InlineResponse2004ConfigChallenge | null;
  /**
   *
   * @type {InlineResponse2004ConfigLive}
   * @memberof InlineResponse2004Config
   */
  live?: InlineResponse2004ConfigLive | null;
}
/**
 *
 * @export
 * @interface InlineResponse2004ConfigChallenge
 */
export interface InlineResponse2004ConfigChallenge {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004ConfigChallenge
   */
  finishTimestamp?: number | null;
}
/**
 *
 * @export
 * @interface InlineResponse2004ConfigLive
 */
export interface InlineResponse2004ConfigLive {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004ConfigLive
   */
  startAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004ConfigLive
   */
  duration?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004ConfigLive
   */
  linkToZoom?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004ConfigLive
   */
  requirements?: string | null;
  /**
   *
   * @type {InlineResponse2004ConfigLiveRecord}
   * @memberof InlineResponse2004ConfigLive
   */
  record?: InlineResponse2004ConfigLiveRecord | null;
  /**
   *
   * @type {Array<InlineResponse2004ConfigLiveTestimonials>}
   * @memberof InlineResponse2004ConfigLive
   */
  testimonials?: Array<InlineResponse2004ConfigLiveTestimonials>;
}
/**
 *
 * @export
 * @interface InlineResponse2004ConfigLiveRecord
 */
export interface InlineResponse2004ConfigLiveRecord {
  /**
   *
   * @type {object}
   * @memberof InlineResponse2004ConfigLiveRecord
   */
  meta?: object | null;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse2004ConfigLiveRecord
   */
  video?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse2004ConfigLiveRecord
   */
  cover?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse2004ConfigLiveTestimonials
 */
export interface InlineResponse2004ConfigLiveTestimonials {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004ConfigLiveTestimonials
   */
  title?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004ConfigLiveTestimonials
   */
  authorName?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004ConfigLiveTestimonials
   */
  review?: string;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse2004ConfigLiveTestimonials
   */
  avatar?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse2004Creator
 */
export interface InlineResponse2004Creator {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004Creator
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2004Creator
   */
  name?: string;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse2004Creator
   */
  avatar?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
}
/**
 *
 * @export
 * @interface InlineResponse2004MarketingPriceConfig
 */
export interface InlineResponse2004MarketingPriceConfig {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004MarketingPriceConfig
   */
  previousPrice?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004MarketingPriceConfig
   */
  iosPrice?: number;
}
/**
 *
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2005
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2005
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2005
   */
  isAvatar?: boolean;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse2005
   */
  avatar?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  subscriptionPrice?: number | null;
  /**
   *
   * @type {Array<InlineResponse2005Spaces>}
   * @memberof InlineResponse2005
   */
  spaces?: Array<InlineResponse2005Spaces>;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2005
   */
  isFollowed?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2005
   */
  isSubscribed?: boolean;
}
/**
 *
 * @export
 * @interface InlineResponse2005Config
 */
export interface InlineResponse2005Config {
  /**
   *
   * @type {InlineResponse2004ConfigChallenge}
   * @memberof InlineResponse2005Config
   */
  challenge?: InlineResponse2004ConfigChallenge | null;
}
/**
 *
 * @export
 * @interface InlineResponse2005Spaces
 */
export interface InlineResponse2005Spaces {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005Spaces
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2005Spaces
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005Spaces
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2005Spaces
   */
  type?: InlineResponse2005SpacesTypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2005Spaces
   */
  payment_type?: InlineResponse2005SpacesPaymentTypeEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005Spaces
   */
  coverFileId?: number;
  /**
   *
   * @type {InlineResponse2005Config}
   * @memberof InlineResponse2005Spaces
   */
  config?: InlineResponse2005Config | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2005Spaces
   */
  isPurchased?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2005Spaces
   */
  isTrial?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2005Spaces
   */
  isSubscribed?: boolean;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse2005Spaces
   */
  cover?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
}

export const InlineResponse2005SpacesTypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
  Community: 'community',
} as const;

export type InlineResponse2005SpacesTypeEnum =
  typeof InlineResponse2005SpacesTypeEnum[keyof typeof InlineResponse2005SpacesTypeEnum];
export const InlineResponse2005SpacesPaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse2005SpacesPaymentTypeEnum =
  typeof InlineResponse2005SpacesPaymentTypeEnum[keyof typeof InlineResponse2005SpacesPaymentTypeEnum];

/**
 *
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  madeBy?: InlineResponse2006MadeByEnum;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2006
   */
  isCompilation?: boolean;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2006
   */
  size?: InlineResponse2006SizeEnum;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse2006
   */
  cover?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
  /**
   *
   * @type {Array<InlineResponse2006ClubsIds>}
   * @memberof InlineResponse2006
   */
  clubsIds?: Array<InlineResponse2006ClubsIds>;
}

export const InlineResponse2006MadeByEnum = {
  Manual: 'manual',
  Popular: 'popular',
} as const;

export type InlineResponse2006MadeByEnum =
  typeof InlineResponse2006MadeByEnum[keyof typeof InlineResponse2006MadeByEnum];
export const InlineResponse2006SizeEnum = {
  Small: 'small',
  Big: 'big',
} as const;

export type InlineResponse2006SizeEnum = typeof InlineResponse2006SizeEnum[keyof typeof InlineResponse2006SizeEnum];

/**
 *
 * @export
 * @interface InlineResponse2006ClubsIds
 */
export interface InlineResponse2006ClubsIds {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006ClubsIds
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006ClubsIds
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006ClubsIds
   */
  deletedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006ClubsIds
   */
  clubId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006ClubsIds
   */
  categoryId?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006ClubsIds
   */
  order?: number | null;
}
/**
 *
 * @export
 * @interface InlineResponse2007
 */
export interface InlineResponse2007 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  deletedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  madeBy?: InlineResponse2007MadeByEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2007
   */
  config?: object | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2007
   */
  isCompilation?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2007
   */
  coverFileId?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  size?: InlineResponse2007SizeEnum;
  /**
   *
   * @type {Array<InlineResponse2006ClubsIds>}
   * @memberof InlineResponse2007
   */
  clubsIds?: Array<InlineResponse2006ClubsIds>;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse2007
   */
  cover?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
}

export const InlineResponse2007MadeByEnum = {
  Manual: 'manual',
  Popular: 'popular',
} as const;

export type InlineResponse2007MadeByEnum =
  typeof InlineResponse2007MadeByEnum[keyof typeof InlineResponse2007MadeByEnum];
export const InlineResponse2007SizeEnum = {
  Small: 'small',
  Big: 'big',
} as const;

export type InlineResponse2007SizeEnum = typeof InlineResponse2007SizeEnum[keyof typeof InlineResponse2007SizeEnum];

/**
 *
 * @export
 * @interface InlineResponse2008
 */
export interface InlineResponse2008 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  updatedAt?: number | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  deletedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2008
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2008
   */
  madeBy?: InlineResponse2008MadeByEnum;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  order?: number;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2008
   */
  config?: object | null;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2008
   */
  isCompilation?: boolean;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2008
   */
  coverFileId?: number | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2008
   */
  size?: InlineResponse2008SizeEnum;
  /**
   *
   * @type {Array<DiscoverSpacesCategoriesSpacesIds>}
   * @memberof InlineResponse2008
   */
  spacesIds?: Array<DiscoverSpacesCategoriesSpacesIds>;
  /**
   *
   * @type {CreatorCreatorSlugCommunitiesConfigCommunityAvatar}
   * @memberof InlineResponse2008
   */
  cover?: CreatorCreatorSlugCommunitiesConfigCommunityAvatar | null;
}

export const InlineResponse2008MadeByEnum = {
  Manual: 'manual',
  Popular: 'popular',
  All: 'all',
} as const;

export type InlineResponse2008MadeByEnum =
  typeof InlineResponse2008MadeByEnum[keyof typeof InlineResponse2008MadeByEnum];
export const InlineResponse2008SizeEnum = {
  Small: 'small',
  Big: 'big',
} as const;

export type InlineResponse2008SizeEnum = typeof InlineResponse2008SizeEnum[keyof typeof InlineResponse2008SizeEnum];

/**
 *
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  expert?: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  price?: number;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2009
   */
  content?: object | null;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2009
   */
  teaser?: object;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  type?: InlineResponse2009TypeEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  status?: InlineResponse2009StatusEnum;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  payment_type?: InlineResponse2009PaymentTypeEnum;
  /**
   *
   * @type {object}
   * @memberof InlineResponse2009
   */
  meta?: object | null;
  /**
   *
   * @type {InlineResponse2005Config}
   * @memberof InlineResponse2009
   */
  config?: InlineResponse2005Config | null;
  /**
   *
   * @type {ExpertExpertIdSpacesMarketingPriceConfig}
   * @memberof InlineResponse2009
   */
  marketingPriceConfig?: ExpertExpertIdSpacesMarketingPriceConfig;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2009
   */
  isPurchased?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof InlineResponse2009
   */
  isSubscribed?: boolean;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof InlineResponse2009
   */
  userSlug?: string | null;
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  chatId?: number | null;
}

export const InlineResponse2009TypeEnum = {
  Post: 'post',
  Live: 'live',
  Challenge: 'challenge',
  Trailer: 'trailer',
  Channel: 'channel',
  Community: 'community',
} as const;

export type InlineResponse2009TypeEnum = typeof InlineResponse2009TypeEnum[keyof typeof InlineResponse2009TypeEnum];
export const InlineResponse2009StatusEnum = {
  Draft: 'draft',
  Published: 'published',
} as const;

export type InlineResponse2009StatusEnum =
  typeof InlineResponse2009StatusEnum[keyof typeof InlineResponse2009StatusEnum];
export const InlineResponse2009PaymentTypeEnum = {
  FixedPrice: 'fixed_price',
  FixedPriceSubscribersOnly: 'fixed_price_subscribers_only',
  SubscribersOnly: 'subscribers_only',
  Free: 'free',
  MonthlyPrice: 'monthly_price',
} as const;

export type InlineResponse2009PaymentTypeEnum =
  typeof InlineResponse2009PaymentTypeEnum[keyof typeof InlineResponse2009PaymentTypeEnum];

/**
 *
 * @export
 * @interface SpacesSpaceIdChallengeStepsContent
 */
export interface SpacesSpaceIdChallengeStepsContent {
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdChallengeStepsContent
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdChallengeStepsContent
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof SpacesSpaceIdChallengeStepsContent
   */
  updatedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdChallengeStepsContent
   */
  title?: string;
  /**
   *
   * @type {Array<SpacesSpaceIdChallengeStepsContentSlides>}
   * @memberof SpacesSpaceIdChallengeStepsContent
   */
  slides?: Array<SpacesSpaceIdChallengeStepsContentSlides>;
}
/**
 *
 * @export
 * @interface SpacesSpaceIdChallengeStepsContentSlides
 */
export interface SpacesSpaceIdChallengeStepsContentSlides {
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdChallengeStepsContentSlides
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof SpacesSpaceIdChallengeStepsContentSlides
   */
  caption?: string | null;
}
/**
 *
 * @export
 * @interface SpacesSpaceIdChallengeStepsResult
 */
export interface SpacesSpaceIdChallengeStepsResult {
  /**
   *
   * @type {boolean}
   * @memberof SpacesSpaceIdChallengeStepsResult
   */
  isSkipped?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SpacesSpaceIdChallengeStepsResult
   */
  isDone?: boolean;
}

/**
 * ChallengeApi - axios parameter creator
 * @export
 */
export const ChallengeApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Result of feedback form for the step of challenge <br /><br /> <b>Authentication:</b> required
     * @summary Result of feedback form for the step of challenge
     * @param {number} stepId
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    challengeStepsStepIdResultPost: async (
      stepId: number,
      inlineObject?: InlineObject,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'stepId' is not null or undefined
      assertParamExists('challengeStepsStepIdResultPost', 'stepId', stepId);
      const localVarPath = `/challenge/steps/{stepId}/result`.replace(
        `{${'stepId'}}`,
        encodeURIComponent(String(stepId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ChallengeApi - functional programming interface
 * @export
 */
export const ChallengeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ChallengeApiAxiosParamCreator(configuration);
  return {
    /**
     * Result of feedback form for the step of challenge <br /><br /> <b>Authentication:</b> required
     * @summary Result of feedback form for the step of challenge
     * @param {number} stepId
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async challengeStepsStepIdResultPost(
      stepId: number,
      inlineObject?: InlineObject,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.challengeStepsStepIdResultPost(
        stepId,
        inlineObject,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ChallengeApi - factory interface
 * @export
 */
export const ChallengeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ChallengeApiFp(configuration);
  return {
    /**
     * Result of feedback form for the step of challenge <br /><br /> <b>Authentication:</b> required
     * @summary Result of feedback form for the step of challenge
     * @param {number} stepId
     * @param {InlineObject} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    challengeStepsStepIdResultPost(
      stepId: number,
      inlineObject?: InlineObject,
      options?: any,
    ): AxiosPromise<InlineResponse200> {
      return localVarFp
        .challengeStepsStepIdResultPost(stepId, inlineObject, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * ChallengeApi - object-oriented interface
 * @export
 * @class ChallengeApi
 * @extends {BaseAPI}
 */
export class ChallengeApi extends BaseAPI {
  /**
   * Result of feedback form for the step of challenge <br /><br /> <b>Authentication:</b> required
   * @summary Result of feedback form for the step of challenge
   * @param {number} stepId
   * @param {InlineObject} [inlineObject]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ChallengeApi
   */
  public challengeStepsStepIdResultPost(stepId: number, inlineObject?: InlineObject, options?: AxiosRequestConfig) {
    return ChallengeApiFp(this.configuration)
      .challengeStepsStepIdResultPost(stepId, inlineObject, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ClubsApi - axios parameter creator
 * @export
 */
export const ClubsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} clubId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clubsClubIdFollowPost: async (clubId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'clubId' is not null or undefined
      assertParamExists('clubsClubIdFollowPost', 'clubId', clubId);
      const localVarPath = `/clubs/{clubId}/follow`.replace(`{${'clubId'}}`, encodeURIComponent(String(clubId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} clubId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clubsClubIdUnfollowPost: async (clubId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'clubId' is not null or undefined
      assertParamExists('clubsClubIdUnfollowPost', 'clubId', clubId);
      const localVarPath = `/clubs/{clubId}/unfollow`.replace(`{${'clubId'}}`, encodeURIComponent(String(clubId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ClubsApi - functional programming interface
 * @export
 */
export const ClubsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ClubsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} clubId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clubsClubIdFollowPost(
      clubId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clubsClubIdFollowPost(clubId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} clubId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async clubsClubIdUnfollowPost(
      clubId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.clubsClubIdUnfollowPost(clubId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ClubsApi - factory interface
 * @export
 */
export const ClubsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ClubsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} clubId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clubsClubIdFollowPost(clubId: number, options?: any): AxiosPromise<InlineResponse2001> {
      return localVarFp.clubsClubIdFollowPost(clubId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} clubId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    clubsClubIdUnfollowPost(clubId: number, options?: any): AxiosPromise<object> {
      return localVarFp.clubsClubIdUnfollowPost(clubId, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * ClubsApi - object-oriented interface
 * @export
 * @class ClubsApi
 * @extends {BaseAPI}
 */
export class ClubsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} clubId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClubsApi
   */
  public clubsClubIdFollowPost(clubId: number, options?: AxiosRequestConfig) {
    return ClubsApiFp(this.configuration)
      .clubsClubIdFollowPost(clubId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} clubId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ClubsApi
   */
  public clubsClubIdUnfollowPost(clubId: number, options?: AxiosRequestConfig) {
    return ClubsApiFp(this.configuration)
      .clubsClubIdUnfollowPost(clubId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * CreatorApi - axios parameter creator
 * @export
 */
export const CreatorApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} creatorSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorCreatorSlugCommunitiesGet: async (
      creatorSlug: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'creatorSlug' is not null or undefined
      assertParamExists('creatorCreatorSlugCommunitiesGet', 'creatorSlug', creatorSlug);
      const localVarPath = `/creator/{creatorSlug}/communities`.replace(
        `{${'creatorSlug'}}`,
        encodeURIComponent(String(creatorSlug)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CreatorApi - functional programming interface
 * @export
 */
export const CreatorApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CreatorApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} creatorSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorCreatorSlugCommunitiesGet(
      creatorSlug: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2002>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorCreatorSlugCommunitiesGet(creatorSlug, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * CreatorApi - factory interface
 * @export
 */
export const CreatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = CreatorApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} creatorSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorCreatorSlugCommunitiesGet(creatorSlug: string, options?: any): AxiosPromise<Array<InlineResponse2002>> {
      return localVarFp
        .creatorCreatorSlugCommunitiesGet(creatorSlug, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * CreatorApi - object-oriented interface
 * @export
 * @class CreatorApi
 * @extends {BaseAPI}
 */
export class CreatorApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {string} creatorSlug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorApi
   */
  public creatorCreatorSlugCommunitiesGet(creatorSlug: string, options?: AxiosRequestConfig) {
    return CreatorApiFp(this.configuration)
      .creatorCreatorSlugCommunitiesGet(creatorSlug, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * CreatorsApi - axios parameter creator
 * @export
 */
export const CreatorsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdGet: async (creatorId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'creatorId' is not null or undefined
      assertParamExists('creatorsCreatorIdGet', 'creatorId', creatorId);
      const localVarPath = `/creators/{creatorId}`.replace(`{${'creatorId'}}`, encodeURIComponent(String(creatorId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdSpacesSpaceIdGet: async (
      creatorId: number,
      spaceId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'creatorId' is not null or undefined
      assertParamExists('creatorsCreatorIdSpacesSpaceIdGet', 'creatorId', creatorId);
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('creatorsCreatorIdSpacesSpaceIdGet', 'spaceId', spaceId);
      const localVarPath = `/creators/{creatorId}/spaces/{spaceId}`
        .replace(`{${'creatorId'}}`, encodeURIComponent(String(creatorId)))
        .replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {number} spaceId
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdSpacesSpaceIdMembersGet: async (
      creatorId: number,
      spaceId: number,
      limit?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'creatorId' is not null or undefined
      assertParamExists('creatorsCreatorIdSpacesSpaceIdMembersGet', 'creatorId', creatorId);
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('creatorsCreatorIdSpacesSpaceIdMembersGet', 'spaceId', spaceId);
      const localVarPath = `/creators/{creatorId}/spaces/{spaceId}/members`
        .replace(`{${'creatorId'}}`, encodeURIComponent(String(creatorId)))
        .replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CreatorsApi - functional programming interface
 * @export
 */
export const CreatorsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CreatorsApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsCreatorIdGet(
      creatorId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsCreatorIdGet(creatorId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsCreatorIdSpacesSpaceIdGet(
      creatorId: number,
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2004>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsCreatorIdSpacesSpaceIdGet(
        creatorId,
        spaceId,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {number} spaceId
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creatorsCreatorIdSpacesSpaceIdMembersGet(
      creatorId: number,
      spaceId: number,
      limit?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.creatorsCreatorIdSpacesSpaceIdMembersGet(
        creatorId,
        spaceId,
        limit,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * CreatorsApi - factory interface
 * @export
 */
export const CreatorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = CreatorsApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdGet(creatorId: number, options?: any): AxiosPromise<InlineResponse2005> {
      return localVarFp.creatorsCreatorIdGet(creatorId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdSpacesSpaceIdGet(
      creatorId: number,
      spaceId: number,
      options?: any,
    ): AxiosPromise<InlineResponse2004> {
      return localVarFp
        .creatorsCreatorIdSpacesSpaceIdGet(creatorId, spaceId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} creatorId
     * @param {number} spaceId
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creatorsCreatorIdSpacesSpaceIdMembersGet(
      creatorId: number,
      spaceId: number,
      limit?: number,
      options?: any,
    ): AxiosPromise<InlineResponse2003> {
      return localVarFp
        .creatorsCreatorIdSpacesSpaceIdMembersGet(creatorId, spaceId, limit, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * CreatorsApi - object-oriented interface
 * @export
 * @class CreatorsApi
 * @extends {BaseAPI}
 */
export class CreatorsApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} creatorId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsCreatorIdGet(creatorId: number, options?: AxiosRequestConfig) {
    return CreatorsApiFp(this.configuration)
      .creatorsCreatorIdGet(creatorId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} creatorId
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsCreatorIdSpacesSpaceIdGet(creatorId: number, spaceId: number, options?: AxiosRequestConfig) {
    return CreatorsApiFp(this.configuration)
      .creatorsCreatorIdSpacesSpaceIdGet(creatorId, spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} creatorId
   * @param {number} spaceId
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreatorsApi
   */
  public creatorsCreatorIdSpacesSpaceIdMembersGet(
    creatorId: number,
    spaceId: number,
    limit?: number,
    options?: AxiosRequestConfig,
  ) {
    return CreatorsApiFp(this.configuration)
      .creatorsCreatorIdSpacesSpaceIdMembersGet(creatorId, spaceId, limit, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * DiscoverApi - axios parameter creator
 * @export
 */
export const DiscoverApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    discoverClubsCategoriesCategoryIdGet: async (
      categoryId: number,
      limit?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'categoryId' is not null or undefined
      assertParamExists('discoverClubsCategoriesCategoryIdGet', 'categoryId', categoryId);
      const localVarPath = `/discover/clubs/categories/{categoryId}`.replace(
        `{${'categoryId'}}`,
        encodeURIComponent(String(categoryId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    discoverClubsCategoriesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/discover/clubs/categories`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    discoverSpacesCategoriesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/discover/spaces/categories`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DiscoverApi - functional programming interface
 * @export
 */
export const DiscoverApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DiscoverApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async discoverClubsCategoriesCategoryIdGet(
      categoryId: number,
      limit?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2006>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.discoverClubsCategoriesCategoryIdGet(
        categoryId,
        limit,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async discoverClubsCategoriesGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2007>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.discoverClubsCategoriesGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async discoverSpacesCategoriesGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2008>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.discoverSpacesCategoriesGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * DiscoverApi - factory interface
 * @export
 */
export const DiscoverApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = DiscoverApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} categoryId
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    discoverClubsCategoriesCategoryIdGet(
      categoryId: number,
      limit?: number,
      options?: any,
    ): AxiosPromise<InlineResponse2006> {
      return localVarFp
        .discoverClubsCategoriesCategoryIdGet(categoryId, limit, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    discoverClubsCategoriesGet(options?: any): AxiosPromise<Array<InlineResponse2007>> {
      return localVarFp.discoverClubsCategoriesGet(options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    discoverSpacesCategoriesGet(options?: any): AxiosPromise<Array<InlineResponse2008>> {
      return localVarFp.discoverSpacesCategoriesGet(options).then(request => request(axios, basePath));
    },
  };
};

/**
 * DiscoverApi - object-oriented interface
 * @export
 * @class DiscoverApi
 * @extends {BaseAPI}
 */
export class DiscoverApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} categoryId
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DiscoverApi
   */
  public discoverClubsCategoriesCategoryIdGet(categoryId: number, limit?: number, options?: AxiosRequestConfig) {
    return DiscoverApiFp(this.configuration)
      .discoverClubsCategoriesCategoryIdGet(categoryId, limit, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DiscoverApi
   */
  public discoverClubsCategoriesGet(options?: AxiosRequestConfig) {
    return DiscoverApiFp(this.configuration)
      .discoverClubsCategoriesGet(options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DiscoverApi
   */
  public discoverSpacesCategoriesGet(options?: AxiosRequestConfig) {
    return DiscoverApiFp(this.configuration)
      .discoverSpacesCategoriesGet(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * ExpertApi - axios parameter creator
 * @export
 */
export const ExpertApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} expertId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertExpertIdSpacesGet: async (expertId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'expertId' is not null or undefined
      assertParamExists('expertExpertIdSpacesGet', 'expertId', expertId);
      const localVarPath = `/expert/{expertId}/spaces`.replace(`{${'expertId'}}`, encodeURIComponent(String(expertId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/expert`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ExpertApi - functional programming interface
 * @export
 */
export const ExpertApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ExpertApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} expertId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expertExpertIdSpacesGet(
      expertId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse2009>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expertExpertIdSpacesGet(expertId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async expertGet(
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse20010>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.expertGet(options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * ExpertApi - factory interface
 * @export
 */
export const ExpertApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ExpertApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} expertId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertExpertIdSpacesGet(expertId: number, options?: any): AxiosPromise<Array<InlineResponse2009>> {
      return localVarFp.expertExpertIdSpacesGet(expertId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    expertGet(options?: any): AxiosPromise<Array<InlineResponse20010>> {
      return localVarFp.expertGet(options).then(request => request(axios, basePath));
    },
  };
};

/**
 * ExpertApi - object-oriented interface
 * @export
 * @class ExpertApi
 * @extends {BaseAPI}
 */
export class ExpertApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} expertId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpertApi
   */
  public expertExpertIdSpacesGet(expertId: number, options?: AxiosRequestConfig) {
    return ExpertApiFp(this.configuration)
      .expertExpertIdSpacesGet(expertId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExpertApi
   */
  public expertGet(options?: AxiosRequestConfig) {
    return ExpertApiFp(this.configuration)
      .expertGet(options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * SpacesApi - axios parameter creator
 * @export
 */
export const SpacesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdAddTrailerToHomePost: async (
      spaceId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdAddTrailerToHomePost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/addTrailerToHome`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengeStepsGet: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengeStepsGet', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/challenge/steps`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengeTrialPost: async (
      spaceId: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdChallengeTrialPost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/challenge/trial`.replace(
        `{${'spaceId'}}`,
        encodeURIComponent(String(spaceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdFollowPost: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdFollowPost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/follow`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdGet: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdGet', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdMembersGet: async (
      spaceId: number,
      limit?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdMembersGet', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/members`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdUnfollowPost: async (spaceId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'spaceId' is not null or undefined
      assertParamExists('spacesSpaceIdUnfollowPost', 'spaceId', spaceId);
      const localVarPath = `/spaces/{spaceId}/unfollow`.replace(`{${'spaceId'}}`, encodeURIComponent(String(spaceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SpacesApi - functional programming interface
 * @export
 */
export const SpacesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SpacesApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdAddTrailerToHomePost(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdAddTrailerToHomePost(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdChallengeStepsGet(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InlineResponse20011>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdChallengeStepsGet(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdChallengeTrialPost(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20012>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdChallengeTrialPost(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdFollowPost(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20013>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdFollowPost(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdGet(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20015>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdGet(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdMembersGet(
      spaceId: number,
      limit?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20014>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdMembersGet(spaceId, limit, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async spacesSpaceIdUnfollowPost(
      spaceId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20013>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.spacesSpaceIdUnfollowPost(spaceId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * SpacesApi - factory interface
 * @export
 */
export const SpacesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = SpacesApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdAddTrailerToHomePost(spaceId: number, options?: any): AxiosPromise<object> {
      return localVarFp.spacesSpaceIdAddTrailerToHomePost(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengeStepsGet(spaceId: number, options?: any): AxiosPromise<Array<InlineResponse20011>> {
      return localVarFp.spacesSpaceIdChallengeStepsGet(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdChallengeTrialPost(spaceId: number, options?: any): AxiosPromise<InlineResponse20012> {
      return localVarFp.spacesSpaceIdChallengeTrialPost(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdFollowPost(spaceId: number, options?: any): AxiosPromise<InlineResponse20013> {
      return localVarFp.spacesSpaceIdFollowPost(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdGet(spaceId: number, options?: any): AxiosPromise<InlineResponse20015> {
      return localVarFp.spacesSpaceIdGet(spaceId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdMembersGet(spaceId: number, limit?: number, options?: any): AxiosPromise<InlineResponse20014> {
      return localVarFp.spacesSpaceIdMembersGet(spaceId, limit, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} spaceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    spacesSpaceIdUnfollowPost(spaceId: number, options?: any): AxiosPromise<InlineResponse20013> {
      return localVarFp.spacesSpaceIdUnfollowPost(spaceId, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * SpacesApi - object-oriented interface
 * @export
 * @class SpacesApi
 * @extends {BaseAPI}
 */
export class SpacesApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdAddTrailerToHomePost(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdAddTrailerToHomePost(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdChallengeStepsGet(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdChallengeStepsGet(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdChallengeTrialPost(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdChallengeTrialPost(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdFollowPost(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdFollowPost(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdGet(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdGet(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdMembersGet(spaceId: number, limit?: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdMembersGet(spaceId, limit, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} spaceId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SpacesApi
   */
  public spacesSpaceIdUnfollowPost(spaceId: number, options?: AxiosRequestConfig) {
    return SpacesApiFp(this.configuration)
      .spacesSpaceIdUnfollowPost(spaceId, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSlugGet: async (slug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'slug' is not null or undefined
      assertParamExists('userSlugGet', 'slug', slug);
      const localVarPath = `/user/{slug}`.replace(`{${'slug'}}`, encodeURIComponent(String(slug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} userSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugCreatorsGet: async (userSlug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'userSlug' is not null or undefined
      assertParamExists('userUserSlugCreatorsGet', 'userSlug', userSlug);
      const localVarPath = `/user/{userSlug}/creators`.replace(`{${'userSlug'}}`, encodeURIComponent(String(userSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * userSlug – slug of creator (owner of space) <br /><br /> <b>Authentication:</b> required
     * @summary userSlug – slug of creator (owner of space)
     * @param {string} userSlug
     * @param {string} spaceSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugSpacesSpaceSlugChallengeStepsGet: async (
      userSlug: string,
      spaceSlug: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userSlug' is not null or undefined
      assertParamExists('userUserSlugSpacesSpaceSlugChallengeStepsGet', 'userSlug', userSlug);
      // verify required parameter 'spaceSlug' is not null or undefined
      assertParamExists('userUserSlugSpacesSpaceSlugChallengeStepsGet', 'spaceSlug', spaceSlug);
      const localVarPath = `/user/{userSlug}/spaces/{spaceSlug}/challenge/steps`
        .replace(`{${'userSlug'}}`, encodeURIComponent(String(userSlug)))
        .replace(`{${'spaceSlug'}}`, encodeURIComponent(String(spaceSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} userSlug
     * @param {string} spaceSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugSpacesSpaceSlugChallengeTrialPost: async (
      userSlug: string,
      spaceSlug: string,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userSlug' is not null or undefined
      assertParamExists('userUserSlugSpacesSpaceSlugChallengeTrialPost', 'userSlug', userSlug);
      // verify required parameter 'spaceSlug' is not null or undefined
      assertParamExists('userUserSlugSpacesSpaceSlugChallengeTrialPost', 'spaceSlug', spaceSlug);
      const localVarPath = `/user/{userSlug}/spaces/{spaceSlug}/challenge/trial`
        .replace(`{${'userSlug'}}`, encodeURIComponent(String(userSlug)))
        .replace(`{${'spaceSlug'}}`, encodeURIComponent(String(spaceSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * userSlug – slug of creator (owner of space) <br /><br /> <b>Authentication:</b> required
     * @summary userSlug – slug of creator (owner of space)
     * @param {string} userSlug slug of creator (owner of space)
     * @param {string} spaceSlug
     * @param {boolean} [_short]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugSpacesSpaceSlugGet: async (
      userSlug: string,
      spaceSlug: string,
      _short?: boolean,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userSlug' is not null or undefined
      assertParamExists('userUserSlugSpacesSpaceSlugGet', 'userSlug', userSlug);
      // verify required parameter 'spaceSlug' is not null or undefined
      assertParamExists('userUserSlugSpacesSpaceSlugGet', 'spaceSlug', spaceSlug);
      const localVarPath = `/user/{userSlug}/spaces/{spaceSlug}`
        .replace(`{${'userSlug'}}`, encodeURIComponent(String(userSlug)))
        .replace(`{${'spaceSlug'}}`, encodeURIComponent(String(spaceSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (_short !== undefined) {
        localVarQueryParameter['short'] = _short;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * userSlug – slug of creator (owner of space) <br /><br /> <b>Authentication:</b> required
     * @summary userSlug – slug of creator (owner of space)
     * @param {string} userSlug
     * @param {string} spaceSlug
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugSpacesSpaceSlugMembersGet: async (
      userSlug: string,
      spaceSlug: string,
      limit?: number,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userSlug' is not null or undefined
      assertParamExists('userUserSlugSpacesSpaceSlugMembersGet', 'userSlug', userSlug);
      // verify required parameter 'spaceSlug' is not null or undefined
      assertParamExists('userUserSlugSpacesSpaceSlugMembersGet', 'spaceSlug', spaceSlug);
      const localVarPath = `/user/{userSlug}/spaces/{spaceSlug}/members`
        .replace(`{${'userSlug'}}`, encodeURIComponent(String(userSlug)))
        .replace(`{${'spaceSlug'}}`, encodeURIComponent(String(spaceSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} userSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugUpvoteDelete: async (userSlug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'userSlug' is not null or undefined
      assertParamExists('userUserSlugUpvoteDelete', 'userSlug', userSlug);
      const localVarPath = `/user/{userSlug}/upvote`.replace(`{${'userSlug'}}`, encodeURIComponent(String(userSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} userSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugUpvotePost: async (userSlug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'userSlug' is not null or undefined
      assertParamExists('userUserSlugUpvotePost', 'userSlug', userSlug);
      const localVarPath = `/user/{userSlug}/upvote`.replace(`{${'userSlug'}}`, encodeURIComponent(String(userSlug)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userSlugGet(
      slug: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20016>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userSlugGet(slug, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} userSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userUserSlugCreatorsGet(
      userSlug: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20017>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userUserSlugCreatorsGet(userSlug, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * userSlug – slug of creator (owner of space) <br /><br /> <b>Authentication:</b> required
     * @summary userSlug – slug of creator (owner of space)
     * @param {string} userSlug
     * @param {string} spaceSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userUserSlugSpacesSpaceSlugChallengeStepsGet(
      userSlug: string,
      spaceSlug: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20018>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userUserSlugSpacesSpaceSlugChallengeStepsGet(
        userSlug,
        spaceSlug,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} userSlug
     * @param {string} spaceSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userUserSlugSpacesSpaceSlugChallengeTrialPost(
      userSlug: string,
      spaceSlug: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20012>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userUserSlugSpacesSpaceSlugChallengeTrialPost(
        userSlug,
        spaceSlug,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * userSlug – slug of creator (owner of space) <br /><br /> <b>Authentication:</b> required
     * @summary userSlug – slug of creator (owner of space)
     * @param {string} userSlug slug of creator (owner of space)
     * @param {string} spaceSlug
     * @param {boolean} [_short]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userUserSlugSpacesSpaceSlugGet(
      userSlug: string,
      spaceSlug: string,
      _short?: boolean,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20019>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userUserSlugSpacesSpaceSlugGet(
        userSlug,
        spaceSlug,
        _short,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * userSlug – slug of creator (owner of space) <br /><br /> <b>Authentication:</b> required
     * @summary userSlug – slug of creator (owner of space)
     * @param {string} userSlug
     * @param {string} spaceSlug
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userUserSlugSpacesSpaceSlugMembersGet(
      userSlug: string,
      spaceSlug: string,
      limit?: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userUserSlugSpacesSpaceSlugMembersGet(
        userSlug,
        spaceSlug,
        limit,
        options,
      );
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} userSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userUserSlugUpvoteDelete(
      userSlug: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20020>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userUserSlugUpvoteDelete(userSlug, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} userSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userUserSlugUpvotePost(
      userSlug: string,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20020>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.userUserSlugUpvotePost(userSlug, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = UserApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userSlugGet(slug: string, options?: any): AxiosPromise<InlineResponse20016> {
      return localVarFp.userSlugGet(slug, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} userSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugCreatorsGet(userSlug: string, options?: any): AxiosPromise<InlineResponse20017> {
      return localVarFp.userUserSlugCreatorsGet(userSlug, options).then(request => request(axios, basePath));
    },
    /**
     * userSlug – slug of creator (owner of space) <br /><br /> <b>Authentication:</b> required
     * @summary userSlug – slug of creator (owner of space)
     * @param {string} userSlug
     * @param {string} spaceSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugSpacesSpaceSlugChallengeStepsGet(
      userSlug: string,
      spaceSlug: string,
      options?: any,
    ): AxiosPromise<InlineResponse20018> {
      return localVarFp
        .userUserSlugSpacesSpaceSlugChallengeStepsGet(userSlug, spaceSlug, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} userSlug
     * @param {string} spaceSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugSpacesSpaceSlugChallengeTrialPost(
      userSlug: string,
      spaceSlug: string,
      options?: any,
    ): AxiosPromise<InlineResponse20012> {
      return localVarFp
        .userUserSlugSpacesSpaceSlugChallengeTrialPost(userSlug, spaceSlug, options)
        .then(request => request(axios, basePath));
    },
    /**
     * userSlug – slug of creator (owner of space) <br /><br /> <b>Authentication:</b> required
     * @summary userSlug – slug of creator (owner of space)
     * @param {string} userSlug slug of creator (owner of space)
     * @param {string} spaceSlug
     * @param {boolean} [_short]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugSpacesSpaceSlugGet(
      userSlug: string,
      spaceSlug: string,
      _short?: boolean,
      options?: any,
    ): AxiosPromise<InlineResponse20019> {
      return localVarFp
        .userUserSlugSpacesSpaceSlugGet(userSlug, spaceSlug, _short, options)
        .then(request => request(axios, basePath));
    },
    /**
     * userSlug – slug of creator (owner of space) <br /><br /> <b>Authentication:</b> required
     * @summary userSlug – slug of creator (owner of space)
     * @param {string} userSlug
     * @param {string} spaceSlug
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugSpacesSpaceSlugMembersGet(
      userSlug: string,
      spaceSlug: string,
      limit?: number,
      options?: any,
    ): AxiosPromise<InlineResponse2003> {
      return localVarFp
        .userUserSlugSpacesSpaceSlugMembersGet(userSlug, spaceSlug, limit, options)
        .then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} userSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugUpvoteDelete(userSlug: string, options?: any): AxiosPromise<InlineResponse20020> {
      return localVarFp.userUserSlugUpvoteDelete(userSlug, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {string} userSlug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userUserSlugUpvotePost(userSlug: string, options?: any): AxiosPromise<InlineResponse20020> {
      return localVarFp.userUserSlugUpvotePost(userSlug, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {string} slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userSlugGet(slug: string, options?: AxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userSlugGet(slug, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {string} userSlug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userUserSlugCreatorsGet(userSlug: string, options?: AxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userUserSlugCreatorsGet(userSlug, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * userSlug – slug of creator (owner of space) <br /><br /> <b>Authentication:</b> required
   * @summary userSlug – slug of creator (owner of space)
   * @param {string} userSlug
   * @param {string} spaceSlug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userUserSlugSpacesSpaceSlugChallengeStepsGet(
    userSlug: string,
    spaceSlug: string,
    options?: AxiosRequestConfig,
  ) {
    return UserApiFp(this.configuration)
      .userUserSlugSpacesSpaceSlugChallengeStepsGet(userSlug, spaceSlug, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {string} userSlug
   * @param {string} spaceSlug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userUserSlugSpacesSpaceSlugChallengeTrialPost(
    userSlug: string,
    spaceSlug: string,
    options?: AxiosRequestConfig,
  ) {
    return UserApiFp(this.configuration)
      .userUserSlugSpacesSpaceSlugChallengeTrialPost(userSlug, spaceSlug, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * userSlug – slug of creator (owner of space) <br /><br /> <b>Authentication:</b> required
   * @summary userSlug – slug of creator (owner of space)
   * @param {string} userSlug slug of creator (owner of space)
   * @param {string} spaceSlug
   * @param {boolean} [_short]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userUserSlugSpacesSpaceSlugGet(
    userSlug: string,
    spaceSlug: string,
    _short?: boolean,
    options?: AxiosRequestConfig,
  ) {
    return UserApiFp(this.configuration)
      .userUserSlugSpacesSpaceSlugGet(userSlug, spaceSlug, _short, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * userSlug – slug of creator (owner of space) <br /><br /> <b>Authentication:</b> required
   * @summary userSlug – slug of creator (owner of space)
   * @param {string} userSlug
   * @param {string} spaceSlug
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userUserSlugSpacesSpaceSlugMembersGet(
    userSlug: string,
    spaceSlug: string,
    limit?: number,
    options?: AxiosRequestConfig,
  ) {
    return UserApiFp(this.configuration)
      .userUserSlugSpacesSpaceSlugMembersGet(userSlug, spaceSlug, limit, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {string} userSlug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userUserSlugUpvoteDelete(userSlug: string, options?: AxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userUserSlugUpvoteDelete(userSlug, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {string} userSlug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public userUserSlugUpvotePost(userSlug: string, options?: AxiosRequestConfig) {
    return UserApiFp(this.configuration)
      .userUserSlugUpvotePost(userSlug, options)
      .then(request => request(this.axios, this.basePath));
  }
}

/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdCreatorsGet: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('usersUserIdCreatorsGet', 'userId', userId);
      const localVarPath = `/users/{userId}/creators`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdGet: async (userId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('usersUserIdGet', 'userId', userId);
      const localVarPath = `/users/{userId}`.replace(`{${'userId'}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersUserIdCreatorsGet(
      userId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20017>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserIdCreatorsGet(userId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usersUserIdGet(
      userId: number,
      options?: AxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse20021>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.usersUserIdGet(userId, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    },
  };
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = UsersApiFp(configuration);
  return {
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdCreatorsGet(userId: number, options?: any): AxiosPromise<InlineResponse20017> {
      return localVarFp.usersUserIdCreatorsGet(userId, options).then(request => request(axios, basePath));
    },
    /**
     * <br /><br /> <b>Authentication:</b> required
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usersUserIdGet(userId: number, options?: any): AxiosPromise<InlineResponse20021> {
      return localVarFp.usersUserIdGet(userId, options).then(request => request(axios, basePath));
    },
  };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersUserIdCreatorsGet(userId: number, options?: AxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersUserIdCreatorsGet(userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * <br /><br /> <b>Authentication:</b> required
   * @param {number} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public usersUserIdGet(userId: number, options?: AxiosRequestConfig) {
    return UsersApiFp(this.configuration)
      .usersUserIdGet(userId, options)
      .then(request => request(this.axios, this.basePath));
  }
}
